var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProPlan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Case"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M4 14.6667L4.20384 18.9692C4.42285 23.5581 4.53236 25.8525 6.07847 27.2596C7.62457 28.6667 10.0362 28.6667 14.8595 28.6667H17.1405C21.9637 28.6667 24.3755 28.6667 25.9216 27.2596C27.4676 25.8525 27.5772 23.5581 27.7961 18.9692L28 14.6667",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M3.79592 13.9241C6.06165 18.2325 11.1719 20 15.9997 20C20.8274 20 25.9377 18.2325 28.2034 13.9241C29.285 11.8674 28.4661 8 25.8023 8H6.19701C3.53332 8 2.71438 11.8674 3.79592 13.9241Z",
    stroke: "currentColor",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M16 14.6667H16.0135",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M21.3337 8L21.2159 7.58791C20.6293 5.53451 20.3359 4.50782 19.6375 3.92057C18.9391 3.33333 18.0115 3.33333 16.1563 3.33333H15.8443C13.9891 3.33333 13.0615 3.33333 12.3631 3.92057C11.6648 4.50782 11.3714 5.53451 10.7847 7.58791L10.667 8",
    stroke: "currentColor",
    strokeWidth: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProPlan);
export default __webpack_public_path__ + "static/media/pro-plan.54ef07114c47261eaf980e84216e9910.svg";
export { ForwardRef as ReactComponent };